import { APIGet } from '../API/APIRequest';

export function GetConfiguration (configurationName, environment) {
    return new Promise((resolve, reject) => {
        let sessionKey = environment ?? "host";
        sessionKey += "_" + configurationName;
        var setting = sessionStorage.getItem(sessionKey);
        var configuration = null;
        if (!setting) {         
            APIGet({
                "controller": "configuration",
                "action": configurationName,
                "environment": environment
            }).then((response) => {
                var result = response.data;
                if (result.success) {
                    configuration = result.configuration;
                    sessionStorage.setItem(sessionKey, JSON.stringify(configuration));
                    resolve(configuration);
                }
                else
                {
                    reject(result.errors);
                }
                //return result.authprovidertype;
            }).catch((error) => {
                reject(error);
            });
        }
        else {
            resolve(JSON.parse(setting));
        }
    });
}

export function GetCurrentBrand(environment) {
    return new Promise((resolve, reject) => {
        let brand = null;
        let brandObj = sessionStorage.getItem("Brand_" + environment);
        if (brandObj) {
            brand = JSON.parse(brandObj);
        }

        if (!brand) {
            APIGet({
                "controller": "brand",
                "action": "getcurrentbrand",
                "environment": environment
            }).then((response) => {
                var result = response.data;
                if (result.success) {
                    brand = result.brand;
                    sessionStorage.setItem("Brand_" + environment, JSON.stringify(brand));
                    resolve(brand);
                }
                else {
                    reject(result.errors);
                }
                //return result.authprovidertype;
            }).catch((error) => {
                reject(error);
            });
        }
        else {
            resolve(brand);
        }
    });
}

export function GetClient(environment) {
    return new Promise((resolve, reject) => {
        var client = sessionStorage.getItem("Client_" + environment);
      
        if (!client) {
            APIGet({
                "controller": "configuration",
                "action": "getclient",
                "environment": environment
            }).then((response) => {
                var result = response.data;
                if (result.success) {
                    client = result.client;
                    sessionStorage.setItem("Client_" + environment, client);
                    resolve(client);
                }
                else {
                    reject(result.errors);
                }
                //return result.authprovidertype;
            }).catch((error) => {
                reject(error);
            });
        }
        else {
            resolve(client);
        }
    });
}

//export { useConfiguration };
   